module.exports = __webpack_public_path__ + "img/left.0fa0472c.png";